import { atom } from 'recoil';
import { getRecoil, setRecoil } from 'recoil-nexus';

import { localStorageEffect, sessionStorageEffect } from '@/utils/atom';

export const CujTestDateState = atom<string[]>({
  key: 'testDate',
  default: [],
  effects: [localStorageEffect('testCujDate')],
});

export const getCujTestDateState = () => {
  return getRecoil(CujTestDateState);
};

export const setCujTestDateState = (date: string[]) => {
  setRecoil(CujTestDateState, date);
};

export type TrackingInfo = {
  campaignName?: string;
  buttonText?: string;
  trackContent?: string;
  contentId?: string;
  contentTitle?: string;
  contentCategory?: string;
  contentSubCategory?: string;
};

export type AppInstallTopBannerStateType = {
  isVisible: boolean;
  expirationTime?: string;
};

type appDownloadCujModalStateType = TrackingInfo & {
  isShow: boolean;
};

export const appDownloadCujModalState = atom<appDownloadCujModalStateType>({
  key: 'appDownloadCujModalState',
  default: {
    isShow: true,
  },
  effects: [sessionStorageEffect('appDownLoadCujModal')],
});

export const appInstallTopBannerState = atom<AppInstallTopBannerStateType>({
  key: 'appInstallTopBannerStateType',
  default: {
    isVisible: false,
    expirationTime: undefined,
  },
  effects: [sessionStorageEffect('appInstallTopBanner')],
});

export const setAppDownloadCujModalState = (state: Partial<appDownloadCujModalStateType>) => {
  setRecoil(appDownloadCujModalState, (current) => {
    return {
      ...current,
      ...state,
    };
  });
};

export const getAppInstallTopBannerState = () => {
  const state = getRecoil(appInstallTopBannerState);

  if (state.expirationTime === undefined) {
    setBannerState({ isVisible: true, expirationTime: undefined });
  }

  if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
    setBannerState({ isVisible: true, expirationTime: undefined });
  }

  return state;
};

// 배너 상태를 설정하는 함수
export const setBannerState = (state: Partial<AppInstallTopBannerStateType>) => {
  setRecoil(appInstallTopBannerState, (current) => {
    return {
      ...current,
      ...state,
    };
  });
};

export const hideBanner = () => {
  const expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
  setBannerState({
    isVisible: false,
    expirationTime: expirationTime,
  });
};
